<organism-modal
    [modalTitle]="TRANSLATION_TITLE_MODAL_CASE_TYPE | translateTokenisedString"
>
    <organism-case-template-search
        [opportunityId]="opportunityId"
        [partyId]="partyId"
        [entityType]="entityType"
        [entityId]="entityId"
        [otherFormInitIds]="otherFormInitIds"
    ></organism-case-template-search>
</organism-modal>
